import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const JourneyToolbar = ({ journeyName, onSave, saving }) => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {journeyName || 'Journey Builder'}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={() => navigate('/crm/journeys')}
          >
            Back to Journeys
          </Button>
          
          <Button
            variant="contained"
            color="primary"
            onClick={onSave}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={20} /> : null}
          >
            {saving ? 'Saving...' : 'Save Journey'}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default JourneyToolbar; 